import React, { useEffect, useState } from 'react'
import usePermission from '../../../config/permissions';
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { CSSForSelect, CSSForSelect10vWWidth, CSSForSelectSmallWidth, customSortByKey, handleErrorToast } from '../../CustomFunctions';
import { AddwithBlueCircle, AddwithWhiteCircle, CrosswithGreyCircle, CrosswithRedCircle, DeleteDustbin, DropdownArrowOption, Eye, UpdatePencil } from '../../AllSvg';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';


const AddApprovalFormat = ({ getApprovalFormat, message }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            format_for: "",
            sub_company: "",
            stages: [
                {
                    role: "",
                    employee: "",
                    level: 1,
                    permissions: "",
                    threshold_approval: false,
                    threshold_amt: "0",
                }
            ],
        })
        setErrors({});
        setInputState({});
        setShow(false)
    };

    const handleShow = () => {
        getEmployee();
        getRole();
        getSubCompany();
        setShow(true)
    };

    const [formData, setFormData] = useState({
        format_for: "",
        sub_company: "",

        stages: [
            {
                role: "",
                employee: "",
                level: 1,
                permissions: "",
                threshold_approval: false,
                threshold_amt: "0",
            }
        ],
    });

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "format_for",
            "sub_company",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });


        formData.stages?.forEach((doc, index) => {
            const hasEmployee = doc.employee && doc.employee.trim() !== "";
            const hasRole = doc.role && doc.role.trim() !== "";

            const isChecked = doc.boolean === true;

            if (!hasEmployee && !hasRole) {
                const message = `Authority Name or Role ${index + 1} is required`;
                newErrors[`employee${index}`] = message;
                newErrors[`role${index}`] = message;
            }

            if (isChecked && (!doc.threshold_amt || doc.threshold_amt.toString().trim() === "")) {
                newErrors[`threshold_amt${index}`] = `Threshold amount ${index + 1} is required `;
            }
        });


        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleStagesInputChanges = (e, index) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === "checkbox" ? checked : value;

        setFormData((prevFormData) => {
            const updatedStages = [...prevFormData.stages];
            updatedStages[index] = {
                ...updatedStages[index],
                [name]: inputValue,
            };
            return { ...prevFormData, stages: updatedStages };
        });
    };

    const handleOtherInputChange = (index, e) => {
        if (!e || !e.target) {
            console.error("Invalid event object: ", e);
            return;
        }
        const { name, value } = e.target;

        if (name === 'employee') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    role: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else if (name === 'role') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    employee: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
    };
    const handleAddOthers = () => {
        setFormData((prevFormData) => {
            const currentApprovalHeading = Array.isArray(prevFormData.stages)
                ? prevFormData.stages
                : [];

            return {
                ...prevFormData,
                stages: [
                    ...currentApprovalHeading,
                    {
                        level: currentApprovalHeading.length + 1,
                        role: "",
                        employee: "",
                    },
                ],
            };
        });
    };


    const handleRemoveOthers = (index) => {
        setFormData((prevFormData) => {
            const currentHeadings = Array.isArray(prevFormData.stages)
                ? [...prevFormData.stages]
                : [];

            currentHeadings.splice(index, 1);

            const updatedOthers = currentHeadings.map((item, idx) => ({
                ...item,
                level: idx + 1,
            }));

            return {
                ...prevFormData,
                stages: updatedOthers,
            };
        });
    };


    const formatList = [
        { value: "Imprest", label: "Imprest" },
        { value: "Expense", label: "Expense" },
        { value: "Vehicle", label: "Vehicle" },
        { value: "Office", label: "Office" },
        { value: "Invoice", label: "Invoice" },
        { value: "BOQ", label: "BOQ" },
    ]


    //******************Valedation End*********************** */

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: name wait..."); //toast Logic
            console.log("formData:", formData)

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/dynamicapprovalscreate/`,
                    formData
                );
                if (res.status === 201) {
                    await getApprovalFormat();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Submitted Successfully")
                }
            } catch (err) {
                console.error(err);

                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    const [buffer1, setBuffering1] = useState(true);
    // const [buffer2, setBuffering2] = useState(true);

    const [departmentlist, setDepartmentList] = useState([]);
    const [allemployeedata, setAllemployee] = useState([]);


    const hiddenOptions = message?.map((item) => item.format_for);



    const [empList, setEmpList] = useState([]);

    const getEmployee = async () => {
        try {
            setBuffering1(true)
            const res = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/null/`);
            setEmpList(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering1(false)
        }
    };

    const [role, setrole] = useState([]);

    const getRole = async () => {
        try {
            setBuffering1(true)
            const res = await axios.get(`${BASE_URL}/siteproject/role/`);
            setrole(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering1(false)
        }
    };


    const employeeOptions = [
        ...empList.map((emp) => ({
            value: emp.id,
            label: `${emp.emp_code} - ${emp.name}`,
        })),
    ];

    const options = role
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.id,
            label: e.role_name
        }));
    const listopotion = formatList
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.value,
            label: e.label
        }));

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }
    const handleFormatChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                format_for: "",
            })

        } else {
            setFormData({
                ...formData,
                format_for: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.format_for;
            return updatedErrors;
        });

    }
    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }

    const subcompanyOption = subcompanyList.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }));


    const permission = [
        { value: "Approve-Reject", label: "Approve-Reject" },
        { value: "Approve-Reject-Edit", label: "Approve-Reject-Edit" },
        { value: "Finalize", label: "Finalize" },
        // {value:"View-Only", label:"View-Only"},
        // {value:"Auto", label:"Auto"},
    ];

    const permissionOption = permission.map((i) => ({
        value: i.value,
        label: i.label,
    }));

    return (
        <>
            <button title="Add approval Format" className="upload-svg equal-hieght" onClick={handleShow}>
                <AddwithWhiteCircle /> Approval Format
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Add Approval Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap ">
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='sub_company'
                                        name='sub_company'
                                        options={subcompanyOption}
                                        isClearable
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                        styles={CSSForSelectSmallWidth}
                                    />

                                    {errors.sub_company && (
                                        <span className="error-message font-size-text">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                        Format For<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='format_for'
                                        name='format_for'
                                        options={listopotion}
                                        isClearable
                                        onChange={handleFormatChange}
                                        value={formatList.find(option => option.value === formData.format_for)}
                                        styles={CSSForSelectSmallWidth}
                                    />

                                    {errors.format_for && (
                                        <span className="error-message font-size-text">
                                            {errors.format_for}
                                        </span>
                                    )}
                                </div>

                            </div>
                            <div className='flex-row justify-end'>
                                <button type='button' title="Add Document" className="upload-svg equal-hieght " onClick={handleAddOthers}>
                                    <AddwithWhiteCircle />
                                    Add More Headings
                                </button>
                            </div>
                            {formData.stages?.map((heading, index) => (
                                <div className=" flex-column " key={index}>

                                    <div className="flex-row justify-between">

                                        <div className='flex-row'>


                                            <div className="flex-column justify-center" style={{ marginTop: "30px", }} >
                                                {heading.level}.
                                            </div>

                                            {heading.employee ? null :
                                                <div className="flex-column form-group-selecttt">
                                                    <label htmlFor="person" className="form-labels font-weight500 font-size-subheading">
                                                        Role<span className="required">*</span>
                                                    </label>
                                                    {/* {buffer2 ? */}
                                                    {/* <div className="form-loader-date">
                                                <div className="bar-loader"></div>
                                            </div> : */}

                                                    <Select
                                                        id='role'
                                                        name='role'
                                                        options={options}
                                                        isClearable
                                                        onChange={(selectedOption) => {
                                                            handleOtherInputChange(index, {
                                                                target: {
                                                                    name: 'role',
                                                                    value: selectedOption ? selectedOption.value : '',
                                                                }
                                                            });
                                                        }}
                                                        value={options.find(option => option.value === heading.role) || null}
                                                        styles={CSSForSelectSmallWidth}
                                                    />

                                                    {/* } */}
                                                    {errors[`role_${index}`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`role_${index}`]}
                                                        </span>
                                                    )}
                                                </div>
                                            }
                                        </div>

                                        {heading.employee === "" && heading.role === "" ?
                                            <div className="flex-row justify-center form-labels font-weight500 font-size-subheading" style={{ marginTop: "30px" }} >
                                                OR
                                            </div>
                                            : null}
                                        {heading.role ? null :
                                            <div className="flex-column">
                                                <div className="expense-req">
                                                    <div className="flex-row">
                                                        <label htmlFor={`department_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                            Authority Name<span className="required">*</span>
                                                        </label>
                                                    </div >
                                                </div>
                                                {buffer1 ?
                                                    <div className="form-loader-date">
                                                        <div className="bar-loader"></div>
                                                    </div> :
                                                    <Select
                                                        options={employeeOptions}
                                                        onChange={(selectedOption) => {
                                                            // Ensure a valid option is selected
                                                            if (selectedOption) {
                                                                handleOtherInputChange(index, {
                                                                    target: {
                                                                        name: 'employee',
                                                                        value: selectedOption.value,
                                                                    }
                                                                });
                                                            } else {
                                                                // Handle case when no option is selected
                                                                handleOtherInputChange(index, {
                                                                    target: {
                                                                        name: 'employee',
                                                                        value: '',
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                        value={employeeOptions.find(option => option.value === heading.emp_name)}
                                                        placeholder="Select Employee"
                                                        // className={`form-input ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""}`}
                                                        isClearable
                                                        noOptionsMessage={() => "No other options"}
                                                        styles={CSSForSelectSmallWidth}

                                                    />
                                                }
                                                {errors[`employee${index}`] && (
                                                    <span className="error-message font-size-text">
                                                        {errors[`employee${index}`]}
                                                    </span>
                                                )}
                                            </div>
                                        }

                                    </div>

                                    <div className="flex-row justify-between">
                                        <div className="flex-column form-group-selectt">
                                            <label htmlFor="permissions" className="form-labels font-weight500 font-size-subheading">
                                                Permission<span className="required">*</span>
                                            </label>
                                            {/* {buffer2 ? */}
                                            {/* <div className="form-loader-date">
                                                <div className="bar-loader"></div>
                                            </div> : */}

                                            <Select
                                                id='permissions'
                                                name='permissions'
                                                options={permissionOption}
                                                isClearable
                                                onChange={(selectedOption) => {
                                                    handleOtherInputChange(index, {
                                                        target: {
                                                            name: 'permissions',
                                                            value: selectedOption ? selectedOption.value : '',
                                                        }
                                                    });
                                                }}
                                                value={permissionOption.find(option => option.value === heading.permissions) || null}
                                                styles={CSSForSelectSmallWidth}
                                            />

                                            {/* } */}
                                            {errors[`permissions_${index}`] && (
                                                <span className="error-message font-size-text">
                                                    {errors[`permissions_${index}`]}
                                                </span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label htmlFor="threshold_approval" className="form-labels font-weight500 font-size-subheading">
                                                Threshold Approval
                                            </label>
                                            <div className='checkbox_container'>

                                                <input
                                                    type="checkbox"
                                                    name={`threshold_approval${index}`}
                                                    style={{ cursor: "pointer" }}
                                                    // checked={heading.threshold_approval}
                                                    value={heading.threshold_amt}
                                                    onChange={(e) => handleStagesInputChanges(e, index)}
                                                    className="checkbox-toggle"
                                                />
                                            </div>


                                            {/* } */}
                                            {errors[`threshold_approval${index}`] && (
                                                <span className="error-message font-size-text">
                                                    {errors[`threshold_approval${index}`]}
                                                </span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Threshold Amount</label>
                                            <input
                                                type="number"
                                                name={`threshold_amt${index}`}
                                                placeholder={"Threshold Amount"}

                                                checked={heading.threshold_amt}
                                                // value={heading.threshold_amt}
                                                onChange={(e) => handleStagesInputChanges(e, index)}
                                                className="form-input width-20vw"
                                                min={0}
                                            />
                                            {errors[`threshold_amt${index}`] && (
                                                <span className="error-message font-size-text">{errors[`threshold_amt${index}`]}</span>
                                            )}
                                        </div>
                                        <div className="flex-column justify-center" >
                                            <button type='button' title="Remove" className="flex-row action-div" onClick={() => handleRemoveOthers(index)}>
                                                <CrosswithRedCircle />
                                            </button>
                                        </div>
                                    </div>




                                </div>
                            ))}



                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};
const UpdateApprovalFormat = ({ getApprovalFormat, message, i }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            format_for: "",
            sub_company_id: "",

            stages: [
                {
                    role: "",
                    employee: "",
                    level: 1,
                }
            ],
        })
        setErrors({});
        setInputState({});
        setShow(false)
    };



    const handleShow = () => {
        getEmployee();
        getRole();
        getSubCompany();
        setFormData(i);
        setShow(true);
    }
    const [formData, setFormData] = useState({
        format_for: "",
        sub_company_id: "",
        stages: [
            {
                role: "",
                employee: "",
                level: 1,
            }
        ],
    });


    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "format_for",
            "sub_company_id"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });


        formData.stages?.forEach((doc, index) => {
            const hasEmployee = doc.employee && doc.employee.trim() !== "";
            const hasRole = doc.role && doc.role.trim() !== "";

            if (!hasEmployee && !hasRole) {
                newErrors[`employee${index}`] = `Authority Name or Role ${index + 1} is required`;
                newErrors[`role${index}`] = `Authority Name or Role ${index + 1} is required`;
            }
        });


        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleOtherInputChange = (index, e) => {
        if (!e || !e.target) {
            console.error("Invalid event object: ", e);
            return;
        }
        const { name, value } = e.target;

        if (name === 'employee') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    role: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else if (name === 'role') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    employee: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
    };


    const handleAddOthers = () => {
        setFormData((prevFormData) => {
            const currentApprovalHeading = Array.isArray(prevFormData.stages)
                ? prevFormData.stages
                : [];

            return {
                ...prevFormData,
                stages: [
                    ...currentApprovalHeading,
                    {
                        level: currentApprovalHeading.length + 1,
                        role: "",
                        employee: "",
                    },
                ],
            };
        });
    };


    const handleRemoveOthers = (index) => {
        setFormData((prevFormData) => {
            const currentHeadings = Array.isArray(prevFormData.stages)
                ? [...prevFormData.stages]
                : [];

            currentHeadings.splice(index, 1);

            const updatedOthers = currentHeadings.map((item, idx) => ({
                ...item,
                level: idx + 1,
            }));

            return {
                ...prevFormData,
                stages: updatedOthers,
            };
        });
    };

    const formatList = [
        { value: "Imprest", label: "Imprest" },
        { value: "Expense", label: "Expense" },
        { value: "Vehicle", label: "Vehicle" },
        { value: "Office", label: "Office" },
        { value: "Invoice", label: "Invoice" },
        { value: "Tender", label: "Tender" },

    ]


    //******************Valedation End*********************** */

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: name wait..."); //toast Logic
            console.log("formData:", formData)

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/dynamicapprovalformatstagesupdate/${i.format_id}/`,
                    formData
                );
                if (res.status === 200) {
                    await getApprovalFormat();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Submitted Successfully")
                } else {
                    console.log("res:", res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const hiddenOptions = message?.map((item) => item.format_for);

    const [empList, setEmpList] = useState([]);
    const [buffer1, setBuffering1] = useState(false)
    const [buffer2, setBuffering2] = useState(false)

    const getEmployee = async () => {
        try {
            setBuffering1(true)
            const res = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/null/`);
            setEmpList(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering1(false);
        }
    };

    const employeeOptions = [
        ...empList.map((emp) => ({
            value: emp.id,
            label: `${emp.emp_code} - ${emp.name}`,
        })),
    ];

    const [role, setrole] = useState([]);

    const getRole = async () => {
        try {
            setBuffering2(true)
            const res = await axios.get(`${BASE_URL}/siteproject/role/`);
            setrole(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering2(false)
        }
    };

    const options = role
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.id,
            label: e.role_name
        }));
    const listopotion = formatList
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.value,
            label: e.label
        }));

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company_id: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company_id: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company_id;
            return updatedErrors;
        });

    }
    const handleFormatChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                format_for: "",
            })

        } else {
            setFormData({
                ...formData,
                format_for: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.format_for;
            return updatedErrors;
        });

    }
    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }


    const subcompanyOption = subcompanyList.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    const permission = [
        { value: "Approve-Reject", label: "Approve-Reject" },
        { value: "Approve-Reject-Edit", label: "Approve-Reject-Edit" },
        { value: "Finalize", label: "Finalize" },
        // {value:"View-Only", label:"View-Only"},
        // {value:"Auto", label:"Auto"},
    ];

    const permissionOption = permission.map((i) => ({
        value: i.value,
        label: i.label,
    }));

    return (
        <>
            <button title="Update Approval Format" className="model-edit-button" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Update Approval Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap ">
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="sub_company_id" className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='sub_company_id'
                                        name='sub_company_id'
                                        options={subcompanyOption}
                                        isClearable
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company_id)}
                                        styles={CSSForSelectSmallWidth}
                                    />

                                    {errors.sub_company_id && (
                                        <span className="error-message font-size-text">
                                            {errors.sub_company_id}
                                        </span>
                                    )}
                                </div>
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                        Format For<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='format_for'
                                        name='format_for'
                                        options={listopotion}
                                        isClearable
                                        onChange={handleFormatChange}
                                        value={formatList.find(option => option.value === formData.format_for)}
                                        styles={CSSForSelectSmallWidth}
                                    />

                                    {errors.format_for && (
                                        <span className="error-message font-size-text">
                                            {errors.format_for}
                                        </span>
                                    )}
                                </div>

                            </div>
                            <div className='flex-row justify-end'>
                                <button type='button' title="Add Document" className="upload-svg equal-hieght " onClick={handleAddOthers}>
                                    <AddwithWhiteCircle />
                                    Add More Headings
                                </button>
                            </div>
                            {formData.stages?.map((heading, index) => (
                                <div className="form-flex-wrap content-tabs " key={index}>

                                    <div className="flex-column justify-center" style={{ marginTop: "30px" }} >
                                        {heading.level}.
                                    </div>



                                    {heading.employee ? null :
                                        <div className="flex-column form-group-selectt">
                                            <label htmlFor="person" className="form-labels font-weight500 font-size-subheading">
                                                Role<span className="required">*</span>
                                            </label>
                                            {buffer2 ?
                                                <div className="form-loader-date">
                                                    <div className="bar-loader"></div>
                                                </div> :

                                                <Select
                                                    id='role'
                                                    name='role'
                                                    options={options}
                                                    isClearable
                                                    onChange={(selectedOption) => {
                                                        handleOtherInputChange(index, {
                                                            target: {
                                                                name: 'role',
                                                                value: selectedOption ? selectedOption.value : '',
                                                            }
                                                        });
                                                    }}
                                                    value={options.find(option => option.value === heading.role) || null}
                                                    styles={CSSForSelectSmallWidth}
                                                />

                                            }
                                            {errors[`role_${index}`] && (
                                                <span className="error-message font-size-text">
                                                    {errors[`role_${index}`]}
                                                </span>
                                            )}
                                        </div>
                                    }

                                    {heading.employee === "" && heading.role === "" ?
                                        <div className="flex-row justify-center form-labels font-weight500 font-size-subheading" style={{ marginTop: "30px" }} >
                                            OR
                                        </div>
                                        : null}
                                    {heading.role ? null :
                                        <div className="flex-column">
                                            <div className="expense-req">
                                                <div className="flex-row">
                                                    <label htmlFor={`department_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                        Authority Name<span className="required">*</span>
                                                    </label>
                                                </div >
                                            </div>
                                            {buffer1 ?
                                                <div className="form-loader-date">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <Select
                                                    options={employeeOptions}
                                                    onChange={(selectedOption) => {
                                                        // Ensure a valid option is selected
                                                        if (selectedOption) {
                                                            handleOtherInputChange(index, {
                                                                target: {
                                                                    name: 'employee',
                                                                    value: selectedOption.value,
                                                                }
                                                            });
                                                        } else {
                                                            // Handle case when no option is selected
                                                            handleOtherInputChange(index, {
                                                                target: {
                                                                    name: 'employee',
                                                                    value: '',
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    value={employeeOptions.find(option => option.value === heading.employee)}
                                                    placeholder="Select or Search Employee"
                                                    // className={`form-input ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""}`}
                                                    isClearable
                                                    noOptionsMessage={() => "No other options"}
                                                    styles={CSSForSelectSmallWidth}

                                                />
                                            }
                                            {errors[`employee${index}`] && (
                                                <span className="error-message font-size-text">
                                                    {errors[`employee${index}`]}
                                                </span>
                                            )}
                                        </div>
                                    }
                                    <div className="flex-column form-group-selectt">
                                        <label htmlFor="permissions" className="form-labels font-weight500 font-size-subheading">
                                            Permission<span className="required">*</span>
                                        </label>
                                        {/* {buffer2 ? */}
                                        {/* <div className="form-loader-date">
                                                <div className="bar-loader"></div>
                                            </div> : */}

                                        <Select
                                            id='permissions'
                                            name='permissions'
                                            options={permissionOption}
                                            isClearable
                                            onChange={(selectedOption) => {
                                                handleOtherInputChange(index, {
                                                    target: {
                                                        name: 'permissions',
                                                        value: selectedOption ? selectedOption.value : '',
                                                    }
                                                });
                                            }}
                                            value={permissionOption.find(option => option.value === heading.permissions) || null}
                                            styles={CSSForSelectSmallWidth}
                                        />

                                        {/* } */}
                                        {errors[`permissions_${index}`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`permissions_${index}`]}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column justify-center" >
                                        <button type='button' title="Remove" className="flex-row action-div" onClick={() => handleRemoveOthers(index)}>
                                            <CrosswithRedCircle />
                                        </button>
                                    </div>

                                </div>
                            ))}



                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const DeleteApprovalFormat = ({ i, getApprovalFormat }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/dynamicapprovalformatstagesupdate/${i.format_id}/`);

            if (res.status === 200) {
                await getApprovalFormat();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Submitted Successfully")
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Format" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {i.format_for} Format </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {i.format_for}'s format data?
                        <div className="button-models">
                            <button className="model-button   font-weight500   model-button-cancel " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


// const ViewApprovalFormatFlow = ({ i }) => {
//     const [show, setShow] = useState(false);
//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     return (
//         <>
//             <button title="View approval Flow" className="" onClick={handleShow}>
//                 <Eye />
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="half-modal ">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Approval Process Flow of "{i.format_for}"</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             {i.stages?.length > 0 ? (
//                                 <ul className="approval-steps">
//                                     {i.stages
//                                         .sort((a, b) => a.level - b.level) // Sort by level just in case
//                                         .map((stage, index) => (
//                                             <li key={stage.id} className="approval-step">
//                                                 <div className="flex-column mb-3">
//                                                     <div className='flex-row justify-between '>
//                                                         <label className="font-weight500 announce-date">
//                                                             <>Stage {stage.level}</>
//                                                         </label>
//                                                         -
//                                                         <div>
//                                                             {stage.role_name ? (
//                                                                 <span>Assigned Role: <strong>{stage.role_name}</strong></span>
//                                                             ) : stage.employee_name ? (
//                                                                 <span>Assigned Authority: <strong>{stage.employee_name}</strong></span>
//                                                             ) : (
//                                                                 <span>Loading...</span>
//                                                             )}
//                                                         </div>
//                                                         -
//                                                         <div>
//                                                             <span>Permissions: <strong>{stage.permissions || 'N/A'}</strong></span>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </li>
//                                         ))}
//                                 </ul>
//                             ) : (
//                                 <p>No stages defined.</p>
//                             )}
//                         </div>
//                     </div>
//                 </Modal.Body>
//             </Modal >
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };
const ViewApprovalFormatFlow = ({ i }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            {/* <button title="View approval Flow" className="" onClick={handleShow}>
                <Eye />
            </button> */}
            <button title="View approval Flow" className="document-download-button  width-5vw  width-5vw" onClick={handleShow}>
                View
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Approval Process Flow of "{i.format_for}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div approval-flow-container">
                            {i.stages?.length > 0 ? (
                                <ul className="approval-steps">
                                    {i.stages
                                        .sort((a, b) => a.level - b.level)
                                        .map((stage) => (
                                            <li key={stage.id} className="approval-step stage-card">
                                                <div className="flex-column mb-3">
                                                    <div className='stage-header'>
                                                        <label className="font-weight500 announce-date">
                                                            Stage {stage.level}
                                                        </label>
                                                    </div>
                                                    <div className="stage-details">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Assigned To {stage.employee_name ? 'Employee' : 'Role'}:</span>
                                                            <span span className="detail-value">
                                                                {stage.role_name || stage.employee_name || 'Not assigned'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Permissions:</span>
                                                            <span className="detail-value">
                                                                {stage.permissions || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Threshold Amount:</span>
                                                            <span className="detail-value">
                                                                {stage.threshold_amt ? `₹${stage.threshold_amt}` : 'Not specified'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Threshold Approval:</span>
                                                            <span className="detail-value">
                                                                {stage.threshold_approval ? 'Required' : 'Not required'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                <p>No stages defined.</p>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
export {
    AddApprovalFormat,
    ViewApprovalFormatFlow,
    UpdateApprovalFormat,
    DeleteApprovalFormat
}